import React from 'react';
import DateFormatter from 'DateFormatter';

function Thumbnail({ articleData }) {
  const articleDate = DateFormatter(articleData.date, 'd M Y');

  if (articleData.image_url) {
    let imageRelativeUrl = articleData.image_url;
    // Check if url is array and contains 's3fs-media' string.
    if (Array.isArray(imageRelativeUrl) && imageRelativeUrl.indexOf('s3fs-media') !== -1) {
      // This will return url string after the '/s3fs-media/' substring.
      [, imageRelativeUrl] = imageRelativeUrl[0].split('/s3fs-media/');
      imageRelativeUrl = `/s3fs-media/${imageRelativeUrl}`;
    }

    return (
      <a href={articleData.url} className="blog-overview__media aspect-ratio aspect-ratio--3-2 media-block--center">
        <img src={imageRelativeUrl} alt={articleData.image_alt} data-rs-carousel-image="" />
      </a>
    );
  }

  const svg = articleData.color === 'dark-blue' ? 'darkblue-bg' : 'yellow-blue-red-turquoise-bg';
  return (
    <a href={articleData.url} className={`blog-overview__media blog-overview__media--border-radius blog-overview__media--s aspect-ratio aspect-ratio--3-2 bg-brand--${articleData.color}`}>
      <img src={`/articles/static/assets/image/article-overview/${svg}.svg`} alt={articleDate} title={articleData.field_title} data-rs-carousel-image="" />
    </a>
  );
}

export default Thumbnail;
